// extracted by mini-css-extract-plugin
module.exports = {"privacyInnerContainer":"PrivacyContentTemplate_privacyInnerContainer__1O-7L","privacyBackButton":"PrivacyContentTemplate_privacyBackButton__3PyXf"};